import gradguardConfig from 'ui/config/gradguard.config';

export default defineAppConfig({
  ...gradguardConfig,
  config: {
    variant: 'variant1',
  },
});
